import { setLocalStore } from "./store/localStore";

/* Set local storage businessDisplayName and authorities */
export const handleChangeRestaurant = (restaurant: any) => {
  const { businessDisplayName, authorities } = restaurant;
  setLocalStore("businessDisplayName", businessDisplayName);
  setLocalStore("authorities", authorities);
};
